/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/arrow_left'
export default icon
